import { useEffect, useState } from 'react'
import { FixedFee, FixedFeesOverview, SiteFixedFeeConfig } from '../../../types/FixedFee'
import { useSites } from '../../../hooks/useSites'
import BackOfficeAPIClient from '../../../clients/BackofficeAPIClient'
import { buildBrandConfigs, countActiveTotal, groupByDealershipId } from '../utils/fixedFeeUtils'
import { buildSaveTargetQuery, SaveTarget } from '../moduleVoNavigation'

const backofficeApiClient = new BackOfficeAPIClient()

// Charge toutes les lignes en une fois (racines + miroirs) et les répartit en 3 listes pour
// la page d'aperçu : global, par site, par marque (cf. buildBrandConfigs pour le regroupement).
export function useFixedFeesOverview(): FixedFeesOverview {
    const sites = useSites()
    const [ data, setData ] = useState<FixedFee[]>([])

    const fetchData = () => {
        backofficeApiClient.get<FixedFee[]>('/inspection-fixed-fee-templates/overview')
            .then(setData)
            .catch(console.log)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const deleteConfig = async (target: SaveTarget) => {
        const query = buildSaveTargetQuery(target)
        await backofficeApiClient.delete(`/inspection-fixed-fee-templates${query}`, undefined)
        fetchData()
    }

    const siteNameById = new Map(sites.map(site => [ site.value, site.label ]))

    const globalData = data.filter(row => row.dealership_id === null && row.brand === null)
    const siteDataById = groupByDealershipId(data.filter(row => row.brand === null))
    const brandScopedData = data.filter(row => row.brand !== null)

    const siteConfigs: SiteFixedFeeConfig[] = Array.from(siteDataById.entries()).map(([ dealershipId, siteRows ]) => ({
        dealershipId,
        siteName: siteNameById.get(dealershipId) ?? `Site ${dealershipId}`,
        linesConfigured: countActiveTotal(siteRows),
    }))

    return {
        sites: sites.map(site => ({ id: site.value, name: site.label })),
        brandConfigs: buildBrandConfigs(brandScopedData, siteNameById),
        siteConfigs,
        globalLinesConfigured: countActiveTotal(globalData),
        deleteConfig,
    }
}
